import { render, staticRenderFns } from "./AuditBadge.vue?vue&type=template&id=3cd9cd82&"
import script from "./AuditBadge.vue?vue&type=script&lang=js&"
export * from "./AuditBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports